import { render, staticRenderFns } from "./SixArticlesSection.vue?vue&type=template&id=bd8d0636&scoped=true&"
import script from "./SixArticlesSection.vue?vue&type=script&lang=js&"
export * from "./SixArticlesSection.vue?vue&type=script&lang=js&"
import style0 from "./SixArticlesSection.vue?vue&type=style&index=0&id=bd8d0636&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8d0636",
  null
  
)

export default component.exports